import axios from 'axios';
import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { IAlarmSettingsDTO } from '@interfaces/alarms/dto/alarmsDTO';
import { TNameTitle } from '@interfaces/common/common';
import { IDownloadUrl } from '@interfaces/common/file';
import { IImportFileDTO } from '@interfaces/import/dto/importDTO';
import { ICategory, ICountry } from '@interfaces/organisation/organisations';
import {
	IRolesResponse,
	IUserListResponse,
} from '@interfaces/user/user';

import { IOrganisationRoleInterface, TOrganizationType } from '@enums/common';

const {
	alarms,
	countriesAll,
	categoriesAll,
	userGroups,
	alarmUsers,
	downloadURL,
	timezonesOptions,
	organisationRoles,
	groups,
	dasNames,
	alarmNodeTypes,
	severities,
	severitiesFlexidas,
	organisationTypes,
	alarmManagementTableOran,
} = URL;

export const getCountries = (): Promise<ICountry[]> => client.get(countriesAll);

export const getTimezones = (): Promise<string[]> => client.get(timezonesOptions);

export const getOrganisationCategories = (): Promise<ICategory[]> => client.get(categoriesAll);

export const getOrganisationTypes = (): Promise<Array<TNameTitle>> => client.get(organisationTypes);

export const getOrganisationRoles = (types: TOrganizationType[]): Promise<IOrganisationRoleInterface[]> => {
	return client.get(organisationRoles, {
		params: {
			types,
		},
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const uploadFileToGcloud = ({ url, data, headers, onProgressHandler }: IImportFileDTO): Promise<void> => {
	return axios.put(url, data, {
		headers: {
			...headers,
			'Content-Type': 'application/octet-stream',
		},
		onUploadProgress: (process) => {
			if (!process.total) return;

			const progress = Math.round((100 * process.loaded) / process.total);

			if (onProgressHandler) onProgressHandler(progress);
		},
	});
};

export const getDownloadURL = (id: string): Promise<IDownloadUrl> => {
	return client.get(downloadURL, {
		params: { id },
	});
};

export const getGroups = (): Promise<Array<TNameTitle>> => client.get(groups);

export const getDasNames = (): Promise<Array<TNameTitle>> => client.get(dasNames);

export const getAlarmNodeTypes = (): Promise<Array<TNameTitle>> => client.get(alarmNodeTypes);

export const getSeverities = (): Promise<Array<TNameTitle>> => client.get(severities);

export const getSeveritiesFlexidas = (): Promise<Array<TNameTitle>> => {
	return client.get(severitiesFlexidas);
};

export const getUserGroups = (): Promise<Array<IRolesResponse>> => client.get(userGroups);

export const getAlarmUsers = (): Promise<Array<IUserListResponse>> => client.get(alarmUsers);

export const updateOranAlarm = ({ id, ...dto }: IAlarmSettingsDTO): Promise<void> => {
	return client.put(`${alarmManagementTableOran}/${id}`, dto);
};

export const updateAlarm = ({
	id,
	isEnabled,
	frequency,
	numberOfRepetitions,
	repetitionHours,
	repetitionMinutes,
	renotify,
	renotifyHours,
	renotifyMinutes,
	isNotification,
	isEmail,
	roles,
	users,
}: IAlarmSettingsDTO): Promise<void> => {
	return client.put(`${alarms}/${id}`, {
		isEnabled,
		frequency,
		numberOfRepetitions,
		repetitionHours,
		repetitionMinutes,
		renotify,
		renotifyHours,
		renotifyMinutes,
		isNotification,
		isEmail,
		roles,
		users,
	});
};
